import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1839752b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "Hero row-start-1 sticky top-0 container place-items-center text-black" };
const _hoisted_2 = { class: "Hero__Title col-span-full text-mobile-display-2 lg:text-desktop-display-1" };
const _hoisted_3 = { class: "SectionDate row-start-1 sticky top-0 z-1 container place-items-center pointer-events-none" };
const _hoisted_4 = { class: "SectionDate__Title col-span-full text-mobile-display-2 lg:text-desktop-display-1 text-accent" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "Page__BackgroundEdge relative row-start-1 self-end -mb-px" }, null, -1));
const _hoisted_6 = { class: "Body relative bg-black text-white" };
const _hoisted_7 = { class: "flex items-end relative z-2 h-screen" };
const _hoisted_8 = { class: "PictureCard__Trigger relative flex flex-row-reverse justify-center items-center w-full before:absolute before:top-1/2 before:bottom-0 before:inset-x-0 before:bg-black" };
const _hoisted_9 = { class: "Card__Trigger" };
const _hoisted_10 = { class: "Card flex items-center h-full" };
const _hoisted_11 = {
    key: 0,
    class: "Picture__Trigger -mr-20"
};
const _hoisted_12 = { class: "Picture size-em text-[28.25rem]" };
const _hoisted_13 = { class: "container relative z-1 place-items-center lg:min-h-screen pt-[50vh] lg:pt-0 text-center bg-black" };
const _hoisted_14 = { class: "Credits__Title col-span-full mb-40 lg:mb-0 text-mobile-h3 lg:text-desktop-h1" };
const _hoisted_15 = { class: "container relative z-1 place-content-center place-items-center gap-y-48 lg:gap-y-64 bg-black" };
const _hoisted_16 = { class: "col-span-full flex flex-col items-center gap-16 lg:gap-32 text-mobile-body lg:text-desktop-body" };
const _hoisted_17 = { class: "flex flex-col items-center gap-12" };
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = { key: 0 };
const _hoisted_20 = {
    key: 0,
    class: "col-span-full hidden lg:block"
};
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("section", { class: "relative z-1 h-screen bg-black" }, null, -1));
const _hoisted_22 = { class: "Shards absolute inset-0 pointer-events-none" };
const _hoisted_23 = { class: "Glass absolute flex justify-center items-center size-0" };
const _hoisted_24 = { class: "Glass absolute flex justify-center items-center size-0" };
const _hoisted_25 = { class: "Glass absolute flex justify-center items-center size-0" };
const _hoisted_26 = {
    class: "Glass absolute flex justify-center items-center size-0",
    "data-start": "200%"
};
const _hoisted_27 = {
    class: "Glass absolute flex justify-center items-center size-0",
    "data-start": "400%"
};
import { onBeforeUnmount, onMounted, ref, computed, toRefs } from "vue";
import { useI18n } from "vue-i18n";
import { unrefElement } from "@vueuse/core";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useAppState } from "@/services/Composition";
import useGSAP from "@/composables/useGSAP";
import Viewport from "@/store/modules/Viewport";
import LayoutTheme, { setHeaderTheme, setFooterTheme } from "@/store/modules/LayoutTheme";
import { setFPS } from "@/utils/frameToTime";
import { round } from "@/utils/number.utils";
import content from "@/config/content";
import PageLayout from "@/components/layout/PageLayout.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Credits',
    setup(__props) {
        const { t, te } = useI18n();
        const gsap = useGSAP();
        const frames = setFPS(60);
        const { send } = useAppState();
        const image = computed(() => {
            const { image } = content.chapters[3];
            return Object.assign(Object.assign({}, image), { src: [`${image.src}.avif`, `${image.src}.webp`] });
        });
        const PARTNERS = [
            {
                logo: [
                    { src: "/assets/images/partners/logo-claimsconference-white.png", srcset: "/assets/images/partners/logo-claimsconference-white.png 1x, /assets/images/partners/logo-claimsconference-white@2x.png 2x", alt: "Claims Conference", width: 288, height: 128, class: "h-96 lg:h-200" },
                    { src: "/assets/images/partners/logos-partners-02-white.png", alt: "Foundation EVZ, Federal Ministry of Finance", width: 535, height: 159, class: "h-[4.4375rem] lg:h-200" },
                ]
            },
            { logo: { src: "/assets/images/partners/logo-usc-shoah-white.png", srcset: "/assets/images/partners/logo-usc-shoah-white.png 1x, /assets/images/partners/logo-usc-shoah-white@2x.png 2x", alt: "USC Shoah Foundation", width: 226, height: 36, class: "h-[2.25rem] lgh-[2.75rem]" } },
            { logo: { src: "/assets/images/partners/logo-makemepulse-white.png", srcset: "/assets/images/partners/logo-makemepulse-white.png 1x, /assets/images/partners/logo-makemepulse-white@2x.png 2x", alt: "makemepulse", width: 150, height: 22, class: "h-20 lg:h-[1.75rem]" } },
            { logo: { src: "/assets/images/partners/logo-unesco-white.png", srcset: "/assets/images/partners/logo-unesco-white.png 1x, /assets/images/partners/logo-unesco-white@2x.png 2x", alt: "unesco", width: 170, height: 36, class: "h-[2.25rem] lg:h-[3.25rem]" } },
            { logo: { src: "/assets/images/partners/logo-meta-white.png", srcset: "/assets/images/partners/logo-meta-white.png 1x, /assets/images/partners/logo-meta-white@2x.png 2x", alt: "Meta", width: 96, height: 20, class: "h-20 lg:h-32" } },
            {},
        ];
        const getPartnerPeople = (index) => {
            const listKey = `credits.partners.${index}.people`;
            if (!te(listKey))
                return [];
            const list = t(listKey);
            return list.split("\n").map((item) => item.split(":").map((part) => part.trim()));
        };
        const layout = ref(null);
        const root = ref(null);
        const scrollEl = ref(null);
        const showCard = ref(false);
        const { isDesktop, isMobile } = toRefs(Viewport);
        let ctx;
        const setup = () => {
            const scroller = scrollEl.value;
            // Background morphing edge
            gsap.to(".Page__BackgroundEdge", {
                keyframes: {
                    scaleY: [0, 1, 0],
                },
                ease: "none",
                scrollTrigger: {
                    scroller,
                    trigger: ".Page__BackgroundEdge",
                    start: "bottom bottom",
                    scrub: true,
                }
            });
            // Update layout theme
            ScrollTrigger.create({
                scroller,
                trigger: ".Body",
                start: () => {
                    const footer = document.querySelector(".AppFooter");
                    const { bottom, height } = footer.getBoundingClientRect();
                    return `top bottom-=${Viewport.windowHeight - bottom + 0.5 * height}px`;
                },
                end: () => {
                    const header = document.querySelector(".AppHeader");
                    const { top, height } = header.getBoundingClientRect();
                    return `top top+=${top + 0.5 * height}px`;
                },
                onEnter: () => setFooterTheme("dark"),
                onLeave: () => setHeaderTheme("dark"),
                onEnterBack: () => setHeaderTheme("light"),
                onLeaveBack: () => setFooterTheme("light"),
            });
            // Section: Date
            ScrollTrigger.create({
                scroller,
                trigger: ".Page__BackgroundEdge",
                start: "top 25%",
                end: "max",
                animation: gsap.effects.heading(".SectionDate__Title"),
                toggleActions: "play none none reset",
            });
            // Picture & Card: appear
            const pictureCardTL = gsap.timeline({
                defaults: {
                    duration: frames(50),
                    ease: "ease.out"
                },
                scrollTrigger: {
                    scroller,
                    trigger: ".PictureCard__Trigger",
                    start: "center bottom",
                    once: true,
                    onEnter: ({ isActive }) => {
                        showCard.value = isActive;
                    }
                }
            });
            if (isDesktop.value) {
                pictureCardTL.fromTo(".Picture", {
                    yPercent: 100,
                    rotation: 70,
                    filter: "brightness(12)"
                }, {
                    motionPath: {
                        path: [{ x: 30, yPercent: 100 }, { x: 10, yPercent: 50 }, { x: 0, yPercent: 0 }],
                        curviness: 2,
                        fromCurrent: false
                    },
                    rotation: -4,
                    filter: "brightness(1)"
                }, 0);
            }
            pictureCardTL.fromTo(".Card", {
                yPercent: 100,
                rotation: 20,
            }, {
                motionPath: {
                    path: [{ x: -50, yPercent: 100 }, { x: -10, yPercent: 50 }, { x: 0, yPercent: 0 }],
                    curviness: 2,
                    fromCurrent: false
                },
                rotation: 2
            }, "<50%");
            // Picture: parallax
            if (isDesktop.value) {
                gsap.fromTo(".Picture__Trigger", {
                    y: () => 0.1 * Viewport.windowHeight,
                }, {
                    y: () => -0.1 * Viewport.windowHeight,
                    ease: "none",
                    scrollTrigger: {
                        scroller,
                        trigger: ".PictureCard__Trigger",
                        scrub: true
                    }
                });
            }
            // Picture & Card: rotation
            gsap.to(".Picture__Trigger, .Card__Trigger", {
                rotation: gsap.utils.wrap([4, -4]),
                ease: "none",
                scrollTrigger: {
                    scroller,
                    trigger: ".PictureCard__Trigger",
                    start: "center bottom",
                    scrub: true
                }
            });
            // Section: Credits
            ScrollTrigger.create({
                scroller,
                trigger: ".Credits__Title",
                start: "center 75%",
                end: "max",
                animation: gsap.effects.heading(".Credits__Title"),
                once: true
            });
        };
        const autoscroll = ref(false);
        const autoscrollSpeed = computed(() => Viewport.isMobile ? 50 : 100);
        const runAutoscroll = (_, deltaTime) => {
            if (!(autoscroll.value && layout.value))
                return;
            const { lenis } = layout.value;
            if (!lenis || lenis.isScrolling === "smooth")
                return;
            const delta = deltaTime * 0.1 * autoscrollSpeed.value / 60;
            lenis.scrollTo(lenis.scroll + delta, {
                force: true,
                lerp: 0,
                easing: gsap.parseEase("linear"),
            });
        };
        function pauseAutoscroll() {
            autoscroll.value = false;
        }
        function resumeAutoscroll() {
            autoscroll.value = true;
        }
        function startAutoscroll() {
            gsap.ticker.add(runAutoscroll);
            resumeAutoscroll();
        }
        function stopAutoscroll() {
            pauseAutoscroll();
            gsap.ticker.remove(runAutoscroll);
        }
        function onEnterPage(el) {
            const $ = gsap.utils.selector(el);
            const tl = gsap.timeline({
                id: "Credits.onEnterPage",
                onComplete: () => onAfterEnterPage(el),
                delay: frames(20),
                defaults: {
                    ease: "ease.out"
                }
            });
            // shards
            const pieces = $(".Glass");
            pieces.forEach((glass, i) => {
                gsap.set(glass, { rotation: gsap.utils.wrap([-30, 30], i) });
                const shard = glass.querySelector(".UIShard");
                const { top, left, right } = shard.getBoundingClientRect();
                gsap.set(glass, {
                    x: [-right, Viewport.windowWidth - left, -10, Viewport.windowWidth - right, -left][i],
                    y: [-100, 100, Viewport.windowHeight - top, Viewport.windowHeight - top, Viewport.windowHeight - top][i]
                });
                if (!("start" in glass.dataset)) {
                    tl
                        .to(glass, {
                        x: 0,
                        y: 0,
                        rotation: 0,
                        duration: frames(100 - i * 10)
                    }, 0);
                }
                tl.call(() => {
                    gsap.effects.float(shard, {
                        amp: 20,
                        duration: [frames(i % 2 === 0 ? 210 : 180), frames(i % 2 === 0 ? 180 : 210)]
                    });
                }, [], ">");
            });
        }
        function onEnterContent(el) {
            const $ = gsap.utils.selector(el);
            // Hero title
            gsap.effects.heading($(".Hero__Title"));
        }
        function onAfterEnterPage(el) {
            var _a, _b;
            const $ = gsap.utils.selector(el);
            const scroller = scrollEl.value;
            // Shards parallax
            const pieces = $(".Glass");
            const shardsKeyframes = [
                [{ x: -60, y: -1 * Viewport.windowHeight, rotation: 40, duration: 1 }],
                [{ x: -100, y: -1 * Viewport.windowHeight, rotation: -60, duration: 1 }],
                [
                    { x: -0.25 * Viewport.windowWidth, y: -120, rotation: 60, duration: 1 },
                    { x: -0.5 * Viewport.windowWidth, y: -0.75 * Viewport.windowHeight, rotation: 170, duration: 1 }
                ],
                [{ x: 0, y: -1.5 * Viewport.windowHeight, rotation: -40, duration: 1.5 }],
                [{ x: 0, y: -1.5 * Viewport.windowHeight, rotation: -46, duration: 1.5 }],
            ];
            pieces.forEach((glass, i) => {
                const keyframes = shardsKeyframes[i];
                const duration = keyframes.reduce((duration, frame) => duration + frame.duration, 0);
                gsap.to(glass, {
                    keyframes,
                    // duration,
                    ease: "none",
                    scrollTrigger: {
                        scroller,
                        start: glass.dataset.start || 0,
                        end: `+=${duration * 100}%`,
                        scrub: 1
                    }
                });
            });
            (_b = (_a = layout.value) === null || _a === void 0 ? void 0 : _a.lenis) === null || _b === void 0 ? void 0 : _b.start();
            startAutoscroll();
        }
        function onBeforeLeave(el) {
            var _a;
            const $ = gsap.utils.selector(el);
            gsap.killTweensOf($(".UIShard"));
            // ensure enter timeline is not running
            (_a = gsap.getById("Credits.onEnterPage")) === null || _a === void 0 ? void 0 : _a.kill();
            stopAutoscroll();
            ctx === null || ctx === void 0 ? void 0 : ctx.kill();
        }
        function onScroll(lenis) {
            round(lenis.progress, 3) === 1 && onEnd();
        }
        function onEnd() {
            send("BACK");
        }
        onMounted(() => {
            if (!layout.value)
                return;
            root.value = unrefElement(layout);
            const { wrapper, lenis } = layout.value;
            scrollEl.value = wrapper;
            lenis.on("scroll", onScroll);
            lenis.stop();
            ctx = gsap.context(setup, root.value);
        });
        onBeforeUnmount(() => {
            onBeforeLeave(root.value);
        });
        return (_ctx, _cache) => {
            const _component_UICard = _resolveComponent("UICard");
            const _component_UIPicture = _resolveComponent("UIPicture");
            const _component_UIIcon = _resolveComponent("UIIcon");
            const _component_UIShard = _resolveComponent("UIShard");
            return (_openBlock(), _createBlock(PageLayout, {
                ref_key: "layout",
                ref: layout,
                class: "Credits",
                onEnter: onEnterPage,
                onEnterContent: onEnterContent,
                onBeforeLeave: onBeforeLeave
            }, {
                ui: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(["hidden lg:flex order-last justify-end items-center gap-40 h-32 mt-auto p-20 lg:p-0", { 'text-white': _unref(LayoutTheme).footer === 'dark', 'text-black': _unref(LayoutTheme).footer === 'light' }])
                    }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("credits.scroll_hint")), 1)
                    ], 2),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_UIShard, { variant: "2" })
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_UIShard, { variant: "2" })
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_UIShard, { variant: "3" })
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_UIShard, { variant: "0" })
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_UIShard, { variant: "1" })
                        ])
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: "Page grid grid-flow-row *:col-start-1",
                        onPointerdown: pauseAutoscroll,
                        onPointerup: resumeAutoscroll
                    }, [
                        _createElementVNode("section", _hoisted_1, [
                            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("credits.page_title")), 1)
                        ]),
                        _createElementVNode("section", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('credits.card.date')), 1)
                        ]),
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("section", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _withDirectives(_createVNode(_component_UICard, {
                                                class: "lg:min-h-[20.125rem]",
                                                title: _ctx.$t('credits.card.title'),
                                                description: _ctx.$t('credits.card.description'),
                                                date: _ctx.$t('credits.card.date'),
                                                place: _ctx.$t('credits.card.place'),
                                                image: _unref(isMobile) ? image.value : undefined,
                                                delay: _unref(frames)(35),
                                                reverse: ""
                                            }, null, 8, ["title", "description", "date", "place", "image", "delay"]), [
                                                [_vShow, showCard.value]
                                            ])
                                        ])
                                    ]),
                                    (_unref(isDesktop))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                            _createElementVNode("div", _hoisted_12, [
                                                _createVNode(_component_UIPicture, _mergeProps({ class: "w-full" }, image.value, { border: "paper" }), null, 16)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createElementVNode("section", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("credits.title")), 1)
                            ]),
                            _createElementVNode("section", _hoisted_15, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(PARTNERS, ({ logo }, i) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                        _createElementVNode("div", _hoisted_16, [
                                            logo
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    (Array.isArray(logo))
                                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(logo, (image) => {
                                                            return (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                                _createElementVNode("img", _mergeProps({ class: "w-auto max-w-none" }, image), null, 16)
                                                            ]));
                                                        }), 256))
                                                        : (_openBlock(), _createElementBlock("img", _mergeProps({
                                                            key: 1,
                                                            class: "w-auto max-w-none"
                                                        }, logo), null, 16))
                                                ], 64))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("p", {
                                                class: "lg:max-w-cols-4 text-center text-pretty",
                                                innerHTML: _ctx.$t(`credits.partners.${i + 1}.description`)
                                            }, null, 8, _hoisted_18),
                                            _createElementVNode("ul", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPartnerPeople(i + 1), ([term, definition], j) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        key: j,
                                                        class: "grid grid-cols-2 gap-x-24 lg:gap-x-88 gap-y-4 lg:gap-y-8"
                                                    }, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass([definition ? 'text-right' : 'col-span-full text-center'])
                                                        }, _toDisplayString(term), 3),
                                                        definition
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(definition), 1))
                                                            : _createCommentVNode("", true)
                                                    ]));
                                                }), 128))
                                            ])
                                        ]),
                                        (i < PARTNERS.length - 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                _createVNode(_component_UIIcon, {
                                                    class: "text-32 text-accent",
                                                    name: "symbol"
                                                })
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 64));
                                }), 64))
                            ]),
                            _hoisted_21
                        ])
                    ], 32)
                ]),
                _: 1
            }, 512));
        };
    }
});
